import { computed, ref } from 'vue'
import api from '@/services/api'
import type { PlayerConfig } from '@/types/shared/player-config'
import { useNow } from '@/composables/game/time'
import { useLocalStorage } from '@vueuse/core'
import { getNextOccurrence } from '@/helpers/date'
import { DateTime } from 'luxon'
import { buildDropeeStorageKey } from '@/config/config'

const maybeConfig = ref<PlayerConfig>()
const config = computed<PlayerConfig>(() => {
  if (!maybeConfig.value) throw new Error('Config is not initialized')
  return maybeConfig.value
})

export const levelNames = ref<Record<number, string>>({})

const cipherConfig = useLocalStorage<{ date: string, size: number[] }>(buildDropeeStorageKey('cipher.size'), {
  date: '',
  size: [],
})

export const useConfig = () => {
  const { nowDateTimestamp } = useNow()
  return {
    config: config,
    cipherConfig: cipherConfig,
    upgrades: computed(() => {
      return config.value.upgrades.filter(u => (u.appearsOn === null || u.appearsOn >= nowDateTimestamp.value) && (u.disappearsOn === null || u.disappearsOn >= nowDateTimestamp.value))
    }),
    cardFastForward: computed(() => config.value.game.ecommerce.prices.cardFastForward),
    syncConfig: async () => {
      const { config, playerStats } = await api.getConfig()
      maybeConfig.value = config
      return { config, playerStats }
    },
    updateConfig: (config: PlayerConfig) => maybeConfig.value = config,
  }
}

async function updateCipherConfig() {
  return
}

export async function initializeCipherConfig() {
  await updateCipherConfig()
  setTimeout(updateCipherConfig, getNextOccurrence(config.value.game.challenges.dailyCipher.endHour).diff(DateTime.utc()).toMillis())
}

export async function initializeConfig() {
  const { config } = await api.getConfig()
  levelNames.value = config.game.levels.reduce<Record<number, string>>((acc, level) => {
    return { ...acc, [level.level]: level.name }
  }, {})
  maybeConfig.value = config
}
